import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";
import paymentPending from "@me-team/common/src/images/payment/payment-pending.png";
import IconLoading from "@me-team/common/src/images/payment/icon-loading.svg";

interface PaymentPendingPageProps {
    onRefetch: () => void;
}

const PaymentPendingPage: React.FC<PaymentPendingPageProps> = ({ onRefetch }) => {
    const { t } = useTranslation();
    const handleButtonRefreshPage = async () => {
        try {
            await onRefetch();
        } catch (error) {
            console.error("Refetch error:", error);
        }
    };

    return (
        <Row className="align-items-center text-dark py-5 bg-white">
            <Col xs={12} lg={6} className="my-auto order-2 order-lg-0">
                <div className="text-center text-lg-start mb-3 mb-lg-4">
                    <IconLoading width={164} height={164} className="img-fluid" />
                </div>
                <h2 className="text-capitalize fw-bold text-center text-lg-start mb-3 col-xxl-9">
                    {t("Thank you for choosing Me-Pos!")}
                </h2>
                <Col xs={12} sm={10} xl={9} className="mx-auto mx-lg-0 mb-5">
                    <p className="text-grey text-center text-lg-start mb-3 me-lg-4">
                        {t(
                            "We are currently processing your transaction. After your payment is confirmed, this page will automatically refresh and you will be able to use the paid functionality. If your browser settings do not allow automatic page refresh, click the Refresh Page button."
                        )}
                    </p>
                    <p className="text-grey text-center text-lg-start mb-0 me-lg-4">
                        {t("If you have any problems, please contact us")}{" "}
                        <a className="text-primary fw-bold text-decoration-none" href="mailto:support@me-pos.com">
                            support@me-pos.com
                        </a>
                    </p>
                </Col>
                <Row>
                    <Col xs={12} lg={6}>
                        <Button
                            onClick={handleButtonRefreshPage}
                            variant="outline-success"
                            className="fs-7 text-capitalize fw-normal rounded-1 w-100 text-truncate"
                        >
                            <i className="bi bi-arrow-repeat me-2"></i>
                            {t("Refresh Page")}
                        </Button>
                    </Col>
                </Row>
            </Col>
            <Col xs={12} lg={6} className="d-flex justify-content-center align-items-center py-5">
                <img
                    src={paymentPending}
                    width="609"
                    height="598"
                    loading="lazy"
                    className="img-fluid"
                    alt={t("Payment pending")}
                />
            </Col>
        </Row>
    );
};

export default PaymentPendingPage;
